import React from 'react';

const companies = [
  { name: 'GitLab', abbr: 'GL' },
  { name: 'Zapier', abbr: 'ZP' },
  { name: 'Automattic', abbr: 'AT' },
  { name: 'Doist', abbr: 'DO' },
  { name: 'Basecamp', abbr: 'BC' },
  { name: 'Buffer', abbr: 'BF' },
  { name: 'Hotjar', abbr: 'HJ' },
  { name: 'InVision', abbr: 'IV' },
  { name: 'Toptal', abbr: 'TP' },
  { name: 'Figma', abbr: 'FG' },
  { name: 'Linear', abbr: 'LN' },
  { name: 'Notion', abbr: 'NT' },
  { name: 'Vercel', abbr: 'VC' },
  { name: 'Supabase', abbr: 'SB' },
  { name: 'PlanetScale', abbr: 'PS' },
  { name: 'Loom', abbr: 'LM' },
  { name: 'Miro', abbr: 'MR' },
  { name: 'Airtable', abbr: 'AB' },
  { name: 'Pitch', abbr: 'PT' },
  { name: 'Deel', abbr: 'DL' },
  { name: 'Remote', abbr: 'RM' },
  { name: 'Oyster', abbr: 'OY' },
];

const LogoChip = ({ name, abbr }: { name: string; abbr: string }) => (
  <a
    href={`https://www.google.com/search?q=${encodeURIComponent(name + ' remote jobs')}`}
    target="_blank"
    rel="noopener noreferrer"
    className="flex items-center gap-2.5 px-5 py-2.5 bg-cloud-white border border-fog-gray rounded-lg shrink-0 group hover:border-signal-blue/30 hover:shadow-sm transition-all cursor-pointer"
  >
    <div className="w-7 h-7 rounded-md bg-slate-pencil/8 flex items-center justify-center">
      <span className="text-[10px] font-bold text-slate-pencil tracking-wider">{abbr}</span>
    </div>
    <span className="text-sm font-medium text-slate-pencil whitespace-nowrap group-hover:text-signal-blue transition-colors">{name}</span>
  </a>
);

export default function LogoMarquee() {
  const doubled = [...companies, ...companies];

  return (
    <div className="relative overflow-hidden">
      {/* Fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

      <div className="flex">
        <div className="marquee-track flex gap-3">
          {doubled.map((company, i) => (
            <LogoChip key={`${company.name}-${i}`} name={company.name} abbr={company.abbr} />
          ))}
        </div>
      </div>
    </div>
  );
}